import {ProgressIndicator, ProgressSpinner} from '@sainsburys-tech/luna-progress'

function LoadingIndicator(props: any) {
  return (
      <>
        <div className="ln-u-text-align-center ln-u-soft" data-test='loading'>
          <ProgressIndicator page loading={props}>
            <ProgressSpinner light/>
            Loading...
          </ProgressIndicator>
        </div>
      </>
  )
}

export default LoadingIndicator
